export const BUILDER_MENU_ITEM_TYPE = 'Builder.MenuItem';
